<template>
  <el-form-item
    v-if="$attrs['prop']"
    :label-width="$attrs['label-width']"
    :prop="$attrs['prop']"
    :label="$attrs['label']"
  >
    <el-select
      v-model="innerValue"
      v-bind="$attrs"
      v-select="{
        value: innerValue,
        list: options,
        directive: directive,
      }"
      class="vab_select"
      :popper-class="textEllipsis ? 'optionsContent' : ''"
      :disabled="$attrs['disabled'] || localDisabled"
      @focus="handleFocus"
      @change="onChange"
      @clear="onClear"
    >
      <!-- 文字超過モード -->
      <template v-if="textEllipsis">
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.label"
            :disabled="item.label.length < 13"
            placement="right"
          >
            <span>{{ item.label }}</span>
          </el-tooltip>
        </el-option>
      </template>
      <template v-else>
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.label"
          :value="item.value"
          :disabled="item.disabled"
        />
      </template>
    </el-select>
    <template #error="{ error }">
      <el-tooltip class="item" effect="dark" :content="error" placement="left">
        <div
          class="el-form-item__error"
          :class="{ error_box: $attrs['error'] == 'true' }"
        >
          {{ error }}
        </div>
      </el-tooltip>
    </template>
  </el-form-item>
  <el-form-item
    v-else
    :label-width="$attrs['label-width']"
    :label="$attrs['label']"
  >
    <el-select
      v-model="innerValue"
      v-bind="$attrs"
      :disabled="$attrs['disabled'] || localDisabled"
      class="vab_select"
      @change="onChange"
      @clear="onClear"
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </el-form-item>
</template>

<script>
  import mixins from '@/utils/mixForm'
  export default {
    name: 'VabSelect',
    componentName: 'VabSelect',
    directives: {
      select: {
        update: function (el, binding) {
          setTimeout(() => {
            if (!binding.value.directive) return
            const defaultValues = binding.value.value
            if (defaultValues) {
              const tags = el.querySelectorAll('.el-tag__close')
              tags.forEach((item) => {
                if (defaultValues.length == 1) {
                  item.style.display = 'none'
                } else {
                  item.style.display = 'block'
                }
              })
            }
          }, 0)
        },
      },
    },
    mixins: [mixins],
    inject: {
      pageComponent: {
        default: '',
      },
    },
    data() {
      return {
        options: [],
      }
    },
    created() {
      this.trigger = 'change'
      this.fetchData()
    },
    methods: {
      fillList(list) {
        if (list && list.length > 0) {
          this.changeList = list
          this.options = []
          list.forEach((item) => {
            this.options.push({
              label: item[this.labelId],
              value: item[this.valueId],
              disabled: item?.disabled,
            })
          })
        } else {
          this.options = []
        }
      },
      reloadList(requestClass, back) {
        //事前調査
        if (
          this.isEqualCodeEnum(
            requestClass,
            this.$divisions.requestClassEnum.enum_1
          )
        ) {
          this.options = []
          this.changeList.forEach((item) => {
            if (
              this.isEqualCodeEnum(
                item[this.valueId],
                this.$divisions.demandTypeEnum.enum_3
              )
            ) {
              this.options.push({
                label: item[this.labelId],
                value: item[this.valueId],
                disabled: false,
              })
            }
          })
          this.innerValue = [this.$divisions.demandTypeEnum.enum_3.value]
        }
        //工事・作業
        if (
          this.isEqualCodeEnum(
            requestClass,
            this.$divisions.requestClassEnum.enum_2
          )
        ) {
          this.options = []
          this.changeList.forEach((item) => {
            if (
              this.isEqualCodeEnum(
                item[this.valueId],
                this.$divisions.demandTypeEnum.enum_2
              ) ||
              this.isEqualCodeEnum(
                item[this.valueId],
                this.$divisions.demandTypeEnum.enum_3
              )
            ) {
              this.options.push({
                label: item[this.labelId],
                value: item[this.valueId],
                disabled: false,
              })
            }
          })
          this.innerValue = [
            this.$divisions.demandTypeEnum.enum_3.value,
            this.$divisions.demandTypeEnum.enum_2.value,
          ]
        }
        back(this.innerValue)
        // this.innerValue = null
      },
      onChange(value) {
        this.handleChange(value)
      },
      onClear() {
        this.handleChange(null)
      },
      setValueMore(val1, val2) {
        setTimeout(() => {
          this.innerValue = [val1, val2]
        }, 0)
      },
      setValue(val) {
        setTimeout(() => {
          this.innerValue = val
        }, 0)
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/vab/styles/component.scss';
</style>
